<template>
    <div class="stone-power-rank-legend">
        <p class="stone-power-rank-legend__level-hint">{{ $t('trainer.stones.rankLegendLevelHint') }}</p>
        <div
            v-for="(name, idx) in ranks"
            :key="idx"
            class="stone-power-rank-legend__row"
        >
            <img
                :src="rankIconSrc(idx)"
                class="stone-power-rank-legend__icon"
                alt=""
            />
            <span class="stone-power-rank-legend__text">
                <span class="stone-power-rank-legend__name">{{ idx + 1 }}. {{ name }}</span>
                <span class="stone-power-rank-legend__range">{{ expRangeLabel(idx) }}</span>
            </span>
        </div>
    </div>
</template>

<script>
    import {StonePowerRankOrder, StonePowerRankThresholds} from "@/utils/itemsEnum";

    export default {
        name: 'StonePowerRankLegend',
        data() {
            return {
                ranks: StonePowerRankOrder,
            }
        },
        methods: {
            rankIconSrc(idx) {
                return require(`@/assets/pic/rank/rank-${idx + 1}.png`);
            },
            expRangeLabel(idx) {
                const min = StonePowerRankThresholds[idx] + 1;
                const max = StonePowerRankThresholds[idx + 1];
                return max
                    ? this.$t('trainer.stones.rankLegendExpRange', {min, max})
                    : this.$t('trainer.stones.rankLegendExpRangeUnbound', {min});
            },
        },
    }
</script>

<style scoped>
.stone-power-rank-legend {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.stone-power-rank-legend__level-hint {
    font-size: 12px;
    opacity: 0.75;
    margin: 0 0 4px;
}

.stone-power-rank-legend__row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stone-power-rank-legend__icon {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
    filter: drop-shadow(0 0 2px rgba(255,215,0,0.9));
}
.theme--dark .stone-power-rank-legend__icon {
    filter: invert(1) drop-shadow(0 0 2px rgba(255,215,0,0.9));
}

.stone-power-rank-legend__text {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
}

.stone-power-rank-legend__name {
    font-size: 14px;
}

.stone-power-rank-legend__range {
    font-size: 11px;
    opacity: 0.7;
    white-space: nowrap;
}
</style>
